import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Dialog, Grid, Box, Typography, Divider } from '@material-ui/core';
import { CheckCircle, ExitToApp } from '@material-ui/icons';
import Button from 'components/Button';

import { handleLogout } from 'pages/Login/store/actions';

export default function PasswordUpdateSuccess({ isOpen, setIsOpen = null }) {
  const dispatch = useDispatch();

  const history = useHistory();

  const steps = [
    {
      id: 1,
      label: 'Saia do aplicativo.'
    },
    {
      id: 2,
      label: 'Faça login com seu e-mail e a nova senha.'
    }
  ];

  return(
    <Dialog
      fullWidth
      maxWidth='sm'
      id='password-update-warning-modal'
      open={isOpen}
      onClose={() => {
        if(setIsOpen) {
          setIsOpen(false);
        }
      }}
      PaperProps={{
        style: {
          height: 'fit-content',
          overflowX: 'hidden'
        }
      }}
    >
      <Grid container style={{ padding: 30 }}>
        <Grid item xs={12}>
          <Grid container xs={12} justify='center'>
            <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '60px', height: '60px', backgroundColor: '#D9F9E6', borderRadius: '50%' }}>
              <CheckCircle fontSize='large' style={{ color: '#44976A' }} />
            </Box>
          </Grid>
          <Grid container xs={12} direction='column' alignItems='center' style={{ marginTop: 10 }}>
            <Typography variant='h5'>
              Senha atualizada com sucesso
            </Typography>
            <Typography variant='body2' color='textSecondary' align='center' style={{ marginTop: 10 }}>
              Para concluir a atualização de segurança, saia e entre novamente no aplicativo usando o e-mail e a nova senha.
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Box style={{ backgroundColor: '#F3F4F8', border: '1px solid #D0D7E4', borderRadius: 15, padding: 10 }}>
            <Box style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 20 }}>
              <ExitToApp color='primary' />
              <Typography variant='body2'>
                Todas as suas sessões do aplicativo operacional foram encerradas automaticamente.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          {steps.map(step => {
            return(
              <Box style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 10, marginTop: 10 }}>
                <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '30px', height: '30px', backgroundColor: '#022A5C', color: '#FFFFFF', borderRadius: '50%' }}>
                  {step.id}
                </Box>
                <Typography variant='body2'>
                  {step.label}
                </Typography>
              </Box>
            );
          })}
        </Grid>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Typography variant='body2' color='textSecondary'>
            Essa medida protege sua conta e ajuda a manter os dados da sua empresa mais seguros.
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Divider />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Button
            fullWidth
            type='button'
            color='success'
            onClick={() => {
              if(setIsOpen) {
                return setIsOpen(false);
              }

              dispatch(handleLogout());
              return history.push('/');
            }}
          >
            Entendi, vou sair e entrar
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
}